import {
  canAccessRoute,
  isPublicRoute,
  isHiddenRoute,
} from "@/core/services/menuPermission.service";

export default function checkMenuPermission({ to, from, next, store }) {
  const isAuthenticated = store.getters.isAuthenticated;
  const currentUser = store.getters.currentUser || {};

  if (!isAuthenticated || isPublicRoute(to.name)) {
    return next();
  }

  if (canAccessRoute(to.name, currentUser)) {
    return next();
  }

  if (isHiddenRoute(to.name)) {
    return next({ name: "404" });
  }

  return next({ name: "permission-denied" });
}
